import axios from "axios";

export default axios.create({
  baseURL: "https://admin.capexfinancialservices.org/api/", 
  headers: {
    "Content-type": "application/json"
  }
});
